import React, { useRef, useState } from "react";
import CountdownCard from "../../components/Countdown";
import IncDecInput from "../../components/IncDecInput";
import InputRemainders from "../../components/InputRemainders";
import {
	BNB,
	Check,
	CheckIcon,
	Close2,
	CopyIcon,
	Dots,
	LineIcon,
	LiquidityLockIcon,
	Lock2,
	User,
	WalletIcon,
} from "../../IconTheme";
import AntexTokenCard from "./components/AntexTokenCard";
import PreSaleInfo from "./components/PreSaleInfo";
import TokenomicsCard from "./components/TokenomicsCard";
import VestingInformation from "./components/VestingInformation";

const LaunchPad = () => {
	const [value, setValue] = useState("0x8489....9391");
	const [copy, setCopy] = useState(false);

	const ref = useRef();
	const handleClick = () => {
		navigator.clipboard.writeText(value);
		setInterval(() => {
			setCopy(false);
		}, 300);
	};

	return (
		<section className="antex-pad-section section-gap">
			<div className="container">
				<div className="row g-3 g-xl-4">
					<div className="col-lg-8">
						<div className="row g-3 g-xl-4">
							<div className="col-12">
								<AntexTokenCard />
							</div>
							<div className="col-12">
								<PreSaleInfo />
							</div>
							<div className="col-12">
								<VestingInformation />
							</div>
						</div>
					</div>
					<div className="col-lg-4">
						<div className="row g-3 g-xl-4">
							<div className="col-lg-12">
								<div className="token-card">
									<div className="token-card-top-area">
										<div className="token-card-top">
											<span>
												<Dots status={false} /> Kyc
											</span>
											<span>
												<Dots status={true} /> Audit
											</span>
											<span className="active">Active</span>
										</div>
										<div className="token-card-middle">
											<div className="cont">
												<div className="info-grp">
													<span
														className="badge badge-md"
														style={{ background: "#f0a500" }}
													>
														<BNB />{" "}
														<span className="text-body">BNB</span>
													</span>
													<span className="badge badge-md">
														<LiquidityLockIcon />
														<span>94.0%</span>
													</span>
													<span className="badge badge-md">
														<LiquidityLockIcon />
														<span>58/400</span>
													</span>
													<span className="badge badge-md">
														<User />
														<span>48/200</span>
													</span>
												</div>
											</div>
										</div>
									</div>
									<ul className="token-leaderboard-list">
										<li>
											<div className="left">
												<div className="icon">
													<Lock2 />
												</div>
												<span>
													<strong>Connected Wallet </strong>
												</span>
											</div>
											<div className="right">
												<input
													type="text"
													ref={ref}
													value={value}
												/>
												<span
													type="button"
													onClick={() => {
														handleClick();
														setCopy(!copy);
													}}
												>
													{!copy ? <CopyIcon /> : "Copied"}
												</span>
											</div>
										</li>
										<li>
											<div className="left">
												<div className="icon">
													<Lock2 />
												</div>
												<span
													style={{ transform: "translateY(2px)" }}
													className="d-inline-flex"
												>
													<strong>Wishlist</strong>
												</span>
											</div>
											<div className="right">
												False
												<span type="button">
													<Close2 />
												</span>
											</div>
										</li>
										<li>
											<div className="left">
												<div className="icon">
													<Lock2 />
												</div>
												<span
													style={{ transform: "translateY(2px)" }}
													className="d-inline-flex"
												>
													<strong>
														Staking Round Eligibility
													</strong>
												</span>
											</div>
											<div className="right">
												True
												<span type="button">
													<Check />
												</span>
											</div>
										</li>
									</ul>
									<div className="token-card-bottom">
										<h6 style={{ fontSize: "16px" }}>
											My Allocation
										</h6>
										<div
											className="progress __progress"
											style={{ height: "20px" }}
										>
											<div
												className="progress-inner"
												style={{ width: `70%`, height: "12px" }}
											></div>
										</div>
										<div className="d-flex justify-content-between align-items-center">
											<span>14 BNB</span>
											<span>25 BNB</span>
										</div>
										<div className="my-4">
											<button className="cmn-btn w-100">
												Join Whitelist
											</button>
										</div>
										<div className="reserve-spots">
											<button className="cmn-btn" type="button">
												<CheckIcon active={true} />
												<span>Reserve Spot</span>
											</button>
											<div className="line">
												<LineIcon />
											</div>
											<button className="cmn-btn" type="button">
												<CheckIcon active={false} />
												<span>Pending</span>
											</button>
										</div>
									</div>
								</div>
							</div>
							<div className="col-lg-12">
								<div className="token-card">
									<div className="token-card-bottom">
										<div className="d-flex justify-content-between align-items-center">
											<span>Round</span>
											<CountdownCard
												targetDate={`January 31, 2024 00:00:00`}
											/>
										</div>
										<div
											className="progress __progress"
											style={{ height: "20px" }}
										>
											<div
												className="progress-inner"
												style={{ width: `36%`, height: "12px" }}
											></div>
										</div>
										<div className="d-flex justify-content-between align-items-center">
											<span>14 BNB</span>
											<span>25 BNB</span>
										</div>
									</div>
								</div>
							</div>
							<div className="col-lg-12">
								<div className="token-card">
									<div className="token-card-bottom">
										<div className="stake-cart-area">
											<IncDecInput />
											<InputRemainders />
										</div>
										<button
											className="cmn-btn justify-content-between d-flex py-1 align-items-center w-100 mt-4 pe-1"
											type="button"
										>
											<span className="mt-1">Connect Wallet</span>
											<WalletIcon />
										</button>
									</div>
								</div>
							</div>
							<div className="col-lg-12">
								<TokenomicsCard />
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default LaunchPad;
